import { useTranslation } from 'react-i18next';
import { environment } from '../utils/environment';
import { useAuth as useOidcAuth } from 'react-oidc-context';
import { useThemeStore } from '../store/theme';

export const useAuth = () => {
  const { i18n } = useTranslation();
  const auth = useOidcAuth();
  const theme = useThemeStore((s) => s.theme);

  const keycloakLogin = async () => {
    const redirectUri = `${location.protocol}${environment.PUBLIC_URL}?theme=${theme}`;

    await auth.signinRedirect({
      redirect_uri: redirectUri,
      scope: 'openid profile email',
      extraQueryParams: {
        ui_locales: i18n.language,
      },
    });
  };

  const keycloakLogout = async () => {
    const currentLanguage = i18n.language;
    const idToken = auth.user?.id_token;
    const redirectUri = `${location.protocol}${environment.PUBLIC_URL}/?theme=${theme}`;

    await auth.signoutRedirect({
      extraQueryParams: {
        ui_locales: currentLanguage,
        ...(theme && { theme }),
        ...(idToken && { id_token_hint: idToken }),
      },
      post_logout_redirect_uri: redirectUri.toString(),
    });
  };

  return {
    auth,
    authenticated: auth.isAuthenticated,
    username: auth.user?.profile.name,
    hasBrokerPanelRole: auth.user?.profile.aud === 'lavva-admin',
    keycloakLogin,
    keycloakLogout,
  };
};
